<template>
  <transition name="fade">
    <div
      :class="['interface', {
        'blur': isBlur
      }]"
      v-if="visible"
      @click="addLevel"
    >
      <i
        class="interface__avatar"
        :style="{
          'background-image': `url(${getAvatarUrl})`
        }"
      />
      <div class="interface__level">
        <span class="interface__level-score">{{ level + 1 }}</span>
        <div class="interface__level-bar">
          <i
            class="interface__level-bar-progress"
            :style="{width: `${levelRelativeScore}%`}"
          />
        </div>
      </div>
      <div class="interface__info">
        <p class="interface__info-name">{{ getName() || 'Студент' }}</p>
        <div class="interface__info-level">{{ LevelRanks[level] }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LevelScores, LevelRanks } from "@/data"

  export default {
    props: {
      isBlur: {
        type: Boolean,
        default: false
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        LevelRanks
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser',
        score: 'getScore',
        level: 'getLevel',
        character: 'getCharacter'
      }),
      levelRelativeScore: {
        get() {
          // max level
          if(typeof LevelScores[this.level + 1] === 'undefined'){
            return 100;
          }

          let currentLevelTotalScore = LevelScores[this.level + 1] - LevelScores[this.level];
          let currentLevelScore =  this.score - LevelScores[this.level];
          return Math.ceil(currentLevelScore * 100 / currentLevelTotalScore);
        }
      },
      getAvatarUrl(){
        return `/images/avatars/${this.character}.png`;
      }
    },
    methods: {
      getName(){
        if(this.user.fio) {
          return this.user.fio.match(/^[А-Яа-яA-Za-z-ё]+\s[А-Яа-яA-Za-z-ё]+|^[А-Яа-яA-Za-z-ё]+/g)[0].split(' ').reverse().join(' ');
        }
      },
      addLevel(){
        this.$store.dispatch('addScore', 10);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .interface {
    position: absolute;
    top: 27px;
    left: 46px;
    color: #FFF;
    transition: filter 200ms, opacity .5s;
    user-select: none;
    z-index: 999;

    &.blur {
      filter: blur(10px);
    }
    &__avatar {
      display: block;
      width: 105px;
      height: 105px;

      background: #000716 center bottom no-repeat;
      background-size: contain;
      border-radius: 50%;
    }
    &__level {
      position: relative;
      z-index: 1;
      margin-top: -15px;

      display: flex;
      align-items: center;

      &-score {
        width: 31px;
        height: 31px;
        text-align: center;
        border-radius: 50%;

        font-size: 29.17px;
        font-weight: bold;
        line-height: 1;

        background-color: #47bd93;

        box-shadow: 0 0 10px #47bd93;
      }
      &-bar {
        position: relative;
        z-index: -1;
        margin-left: -2px;
        width: 186px;

        background-color: #000716;
        border-radius: 0 12px 12px 0;

        &-progress {
          display: block;
          height: 12px;
          background-color: #47bd93;
          border-radius: inherit;
          box-shadow: 0 0 10px #47bd93;
        }
      }
    }
    &__info {
      line-height: 1;
      padding-top: 5px;

      &-name {
        margin-bottom: 3px;
        font-size: 29.17px;
        font-weight: bold;
      }
      &-level {
        font-size: 16px;
      }
    }
  }
</style>
